// extracted by mini-css-extract-plugin
module.exports = {"container":"Alert_container__1yoIc","card":"Alert_card__1Twbf","error":"Alert_error__3ZIRi","success":"Alert_success__-MVQ4","warning":"Alert_warning__3H2g8"};